// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { connect } from "react-redux";
import { FontIcon, ContextualMenuItemType } from "@fluentui/react";
import { IApplicationState } from "../../../models/applicationState";
import { getSubMenuTheme } from "../../../common/themes";
import "./titleBar.scss";

export interface ITitleBarProps extends React.Props<TitleBar> {
    icon?: string | JSX.Element;
    title?: string;
}

export interface ITitleBarState {
    maximized: boolean;
    fullscreen: boolean;
    menu: any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        title: state.appTitle,
    };
}

@connect(mapStateToProps, null)
export class TitleBar extends React.Component<ITitleBarProps, ITitleBarState> {
    public state: ITitleBarState = {
        maximized: false,
        fullscreen: false,
        menu: null,
    };

    private currentWindow: any;

    public componentDidMount() {}

    public render() {
        if (this.state.fullscreen) {
            return null;
        }

        return (
            <div className="title-bar bg-lighter-3">
                <div className="title-bar-icon">
                    {typeof this.props.icon === "string" && (
                        <FontIcon iconName={this.props.icon} />
                    )}
                    {typeof this.props.icon !== "string" && this.props.icon}
                </div>

                <div className="title-bar-main">
                    {this.props.title || "Welcome"}
                </div>
                <div className="title-bar-controls">{this.props.children}</div>
            </div>
        );
    }

    private addDefaultMenuItems = (menu: any) => {
        if (!menu) {
            return null;
        }

        return menu.items.reduce(this.renderMenuItem, []);
    };

    private renderMenuItem = (results, menuItem: any) => {
        if (!menuItem.visible) {
            return null;
        }

        const itemType: string = menuItem["type"];

        switch (itemType) {
            case "separator":
                results.push({
                    key: menuItem.label,
                    itemType: ContextualMenuItemType.Divider,
                });
                break;
            case "submenu":
                results.push({
                    key: menuItem.label,
                    name: menuItem.label,
                    subMenuProps: {
                        theme: getSubMenuTheme(),
                        items: this.addDefaultMenuItems(menuItem["submenu"]),
                    },
                });
                break;
            case "normal":
                results.push({
                    key: menuItem.label,
                    name: menuItem.label,
                    onClick: (e) => this.onMenuItemClick(e, menuItem),
                });
        }
        return results;
    };

    private onMenuItemClick(e: any, menuItem: any) {
        if (menuItem.label === "Zoom In") {
            this.currentWindow.webContents.setZoomLevel(
                this.currentWindow.webContents.getZoomLevel() + 0.3
            );
        } else if (menuItem.label === "Zoom Out") {
            this.currentWindow.webContents.setZoomLevel(
                this.currentWindow.webContents.getZoomLevel() - 0.3
            );
        } else if (menuItem.label === "Reset Zoom") {
            this.currentWindow.webContents.setZoomLevel(0);
        } else if (menuItem.click) {
            menuItem.click.call(menuItem, menuItem, this.currentWindow);
        }
    }
}
